
$(function() {
    //nav tab
    $('.symptoms-sp .title, .keyword-sp .title').on("click", function () {
        var wrap_list = $(this).parent();
        wrap_list.find('.content').slideToggle('300', function() {
            wrap_list.toggleClass('is-open');
        });
    });
    //scroll to top js
    $(window).scroll(function(){
        if ($(this).scrollTop() > 100) {
            $('.pageTop').show().fadeIn();
        } else {
            $('.pageTop').fadeOut().hide();
        }
    });
    $( ".pageTop a" ).click(function() {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    });
    // change tab js section nav tab content
    $( ".nav-tabs li a" ).click(function() {
        $('#large-tab-content').removeClass().addClass('col-md-12 '+ $(this).attr("data-bg"));
    });
    //header menu js in mobile
    $('.menu-mobile').click(function () {
        $('.menuBox').slideToggle(300);
        $('.animated-icon1').toggleClass('open');
        return false;
    });
    //slider
    $('.slider').slick({
        centerMode: true,
        centerPadding: '15%',
        slidesToShow: 1,
        autoplay: true,
        prevArrow:'<button class="PrevArrow"></button>',
        nextArrow:'<button class="NextArrow"></button>',
        responsive: [
            {
                breakpoint: 901,
                settings: {
                    centerMode: false,
                    slidesToShow: 1
                }
            }
        ]
    });
    $(".customer_search").keyup(function (event) {
        if (event.keyCode === 13) {
            searchAction($(this));
        }
    });
    $(".search-button").on("click", function () {
        var select = $(this).parent().find(".customer_search");
        searchAction(select);
    });
    function searchAction(searchInput) {
         var term = searchInput.val();
         if (term != undefined) {
             var author = searchInput.attr('data-author');

             var search_value = term.trim();
             if (search_value.length < 3) {
                 search_value = search_value + '*';
             }
             var searchURL = '/search?type=article&q=title:' + search_value;
             if ((author != '') && (author != undefined)) {
                 searchURL += '+AND+author:' + author.trim();
             }
             //var searchURL = '/search?type=article&q=' + search_value;
             window.location.href = searchURL;
         }
    }
    //Add bookmark
  var bookmarkAction = $(".add-bookmark");
  bookmarkAction.click(function(e) {
    e.preventDefault();
    $(this).html('');
    $(this).parent().addClass('loading-status');
    $(this).html('<a class="loading">読み込み中</a>');
    $(this).removeClass('add-bookmark');
    var handle = $(this).attr("data-article");
    var sig = $(this).attr("data-sig");
      $.ajax({
          type: "POST",
          url: "/apps/app-proxy/add-bookmark",
          dataType: "json",
          data: {sig: sig, handle: handle},
          success: function (response) {
              swal({
                  title: "Thank you",
                  text: "このコンテンツをお気に入りに追加しました。",
                  icon: "success",
              });
              bookmarkAction.addClass("hide");
          },
          error: function (response) {
              swal({
                  title: "エラー",
                  text: "エラーが発生しました。もう一度やり直してください。",
                  icon: "error",
              });
          }
      });
  });
  //Remove bookmark
    $(".remove-bookmark").click(function (e) {
        e.preventDefault();
        $(this).find('.text').html('<a class="loading"></a>');
        var handle = $(this).attr("data-article");
        var sig = $(this).attr("data-sig");
        $(this).removeClass('remove-bookmark');
        $.ajax({
            type: "POST",
            url: "/apps/app-proxy/remove-bookmark",
            dataType: "json",
            data: {sig: sig, handle: handle},
            success: function (response) {
                swal({
                    title: "Thank you",
                    text: "この記事はお気に入りから削除されました。",
                    icon: "success",
                }).then(function () {
                    location.reload();
                });
            },
            error: function (response) {
                swal({
                    title: "エラー",
                    text: "Removed bookmark error !",
                    icon: "error",
                }).then(function () {
                    location.reload();
                });
            }
        });
    });
});